import { MatrixBoard } from '../features/matrix/MatrixBoard.js';

/**
 * Tela da matriz de Eisenhower (spec 9.2).
 *
 * `h-full` mais `min-h-0` nos filhos e o que faz cada quadrante rolar por
 * dentro em vez de esticar a pagina — sem o `min-h-0`, um item de grid recusa
 * encolher abaixo do proprio conteudo e a rolagem interna nunca acontece.
 */
export function Matrix() {
  return (
    <div className="flex h-[calc(100dvh-var(--tabbar-height))] md:h-dvh min-h-0 flex-col gap-2 p-3 md:gap-3 md:p-4">
      {/* So o titulo, como no TickTick (§8ab). A instrucao "arraste um card"
          que vinha embaixo custava uma linha inteira da tela mais apertada do
          app; o gesto e o mesmo das outras telas. */}
      <header>
        <h1 className="font-display text-lg font-semibold">Matriz de Eisenhower</h1>
      </header>

      <MatrixBoard />
    </div>
  );
}
